export default {
  exportButton: 'cursor-pointer',
  exportOptions: 'cursor-pointer ml-[-165px] w-[210px] shadow-[0_5px_40px_0_rgba(0,0,0,0.16)] z-10 px-[11px] py-[13px] rounded-lg bg-color-white',
  exportOption: 'text-color-text px-[13px] py-[11px] hover:bg-[#F0F3F6] flex items-center rounded-lg',
  exportOptionTitle: 'text-[16px] ml-[12px] font-inter',
};
